import Steps from "components/Steps/Steps";
import { useSelector } from "react-redux";

const Modals = () => {
  const { isShowSteps } = useSelector(store => store.ui_control);
  return <>{isShowSteps && <Steps />}</>;
};
export default Modals;
